// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.view-add-doc-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
  width: 100%;
  align-items: flex-start;
}

.view-add-doc-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
  transition: var(--transition);
}

.view-add-doc-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
  text-transform: uppercase;
}

.view-add-doc-title h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-dark);
  font-weight: 600;
}

.view-add-doc-tag {
  display: inline-block;
  margin-top: 0.5rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
}

.view-add-doc-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.view-note-detail-item {
  display: flex;
  gap: 1rem;
}
.view-note-detail-item .icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.view-note-detail-item label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-light);
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-note-detail-item p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
}

.view-add-doc-description {
  font-size: 0.95rem;
  color: var(--text-medium);
  margin-top: 1rem;
  line-height: 1.6;
}

.view-add-doc-document {
  margin-top: 0.5rem;
}
.view-add-doc-document a {
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: underline;
}
.view-add-doc-document a:hover {
  text-decoration: none;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

.error-message {
  text-align: center;
  color: var(--danger-color);
  font-weight: 500;
  font-size: 1rem;
  padding: 2rem;
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .view-add-doc-detail-container {
    padding: 1rem;
  }
  .view-add-doc-card {
    padding: 1.5rem;
  }
  .view-add-doc-details-grid {
    grid-template-columns: 1fr;
  }
}
.upload-section {
  margin-top: 20px;
}
.upload-section .upload-box {
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
  text-align: center;
}
.upload-section .upload-result {
  margin-top: 0.5rem;
}
.upload-section .upload-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.upload-section .upload-progress {
  margin-top: 10px;
}
.upload-section .upload-progress .progress-bar {
  background: #eee;
  height: 6px;
  border-radius: 4px;
  overflow: hidden;
}
.upload-section .upload-progress .progress-fill {
  background: #4caf50;
  height: 100%;
  transition: width 0.3s ease;
}
.upload-section .upload-progress .percent-upload {
  margin-top: 0.5rem;
}
.upload-section .upload-actions {
  display: flex;
  justify-content: end;
  gap: 10px;
  margin-top: 0.5rem;
}
.upload-section .upload-actions button {
  padding: 6px 12px;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.upload-section .upload-actions .cancel-btn {
  background: #ff5e5e;
}
.upload-section .upload-actions .submit-btn {
  background: #4caf50;
}

.view-note-detail-item.clickable {
  cursor: pointer;
}

.court-ref-tooltip {
  text-decoration: underline;
  color: #0066cc;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewAdditionalDoc/ViewAdditionalDoc.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AACF;;AAGE;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EAEA,SAAA;AAFF;AAIE;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AAHJ;AAME;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;AALF;AAME;EACE,gBAAA;EACA,2BAAA;EACA,0BAAA;AAJJ;AAMI;EACE,qBAAA;AAJN;;AASA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AANF;;AASA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AANF;;AASA;EACE;IACE,yBAAA;EANF;AACF;AASA;EACE;IACE,aAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;IACE,0BAAA;EATF;AACF;AAYA;EACE,gBAAA;AAVF;AAYE;EACE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAVJ;AAeE;EACE,kBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAdJ;AAiBE;EACE,gBAAA;AAfJ;AAiBI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAfN;AAkBI;EACE,mBAAA;EACA,YAAA;EACA,2BAAA;AAhBN;AAkBI;EACE,kBAAA;AAhBN;AAoBE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAlBN;AAqBI;EACE,mBAAA;AAnBN;AAsBI;EACE,mBAAA;AApBN;;AAyBA;EACE,eAAA;AAtBF;;AAyBA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;AAtBF","sourcesContent":[":root {\n  --primary-light: #eef2ff;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --text-dark: #1f2937;\n  --text-medium: #4b5563;\n  --text-light: #9ca3af;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  --transition: all 0.3s ease;\n}\n\n.view-add-doc-detail-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.view-add-doc-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  padding: 2rem;\n  transition: var(--transition);\n}\n\n.view-add-doc-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 1.5rem;\n}\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-right: 1.5rem;\n  text-transform: uppercase;\n}\n\n.view-add-doc-title {\n  h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: var(--text-dark);\n    font-weight: 600;\n  }\n}\n\n.view-add-doc-tag {\n  display: inline-block;\n  margin-top: 0.5rem;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.view-add-doc-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.view-note-detail-item {\n  display: flex;\n  // align-items: center;\n  gap: 1rem;\n\n  .icon {\n    font-size: 1.25rem;\n    color: var(--primary-color);\n    margin-top: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  label {\n    display: block;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    color: var(--text-light);\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: var(--text-dark);\n  }\n}\n\n.view-add-doc-description {\n  font-size: 0.95rem;\n  color: var(--text-medium);\n  margin-top: 1rem;\n  line-height: 1.6;\n}\n\n.view-add-doc-document {\n  margin-top: 0.5rem;\n  a {\n    font-weight: 500;\n    color: var(--primary-color);\n    text-decoration: underline;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(67, 97, 238, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 2rem auto;\n}\n\n.error-message {\n  text-align: center;\n  color: var(--danger-color);\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 2rem;\n  width: 100%;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .view-add-doc-detail-container {\n    padding: 1rem;\n  }\n\n  .view-add-doc-card {\n    padding: 1.5rem;\n  }\n\n  .view-add-doc-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.upload-section {\n  margin-top: 20px;\n\n  .upload-box {\n    border: 2px dashed #ccc;\n    padding: 20px;\n    cursor: pointer;\n    text-align: center;\n\n\n  }\n\n  .upload-result {\n    margin-top: 0.5rem;\n  }\n\n  .upload-icon {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .upload-progress {\n    margin-top: 10px;\n\n    .progress-bar {\n      background: #eee;\n      height: 6px;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n\n    .progress-fill {\n      background: #4caf50;\n      height: 100%;\n      transition: width 0.3s ease;\n    }\n    .percent-upload{\n      margin-top: 0.5rem;\n    }\n  }\n\n  .upload-actions {\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    margin-top: 0.5rem;\n\n    button {\n      padding: 6px 12px;\n      color: #fff;\n      font-weight: 600;\n      border: none;\n      border-radius: 5px;\n      cursor: pointer;\n    }\n\n    .cancel-btn {\n      background: #ff5e5e;\n    }\n\n    .submit-btn {\n      background: #4caf50;\n    }\n  }\n}\n\n.view-note-detail-item.clickable {\n  cursor: pointer;\n}\n\n.court-ref-tooltip {\n  text-decoration: underline;\n  color: #0066cc;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
